import api from './client';
export const requestDemo = (data) => api.post('/demo-requests', data).then(r => r.data);
export const getDemoRequests = () => api.get('/platform/demo-requests').then(r => r.data);
export const updateDemoRequest = (id, action, data) => api.post(`/platform/demo-requests/${id}/${action}`, data).then(r => r.data);
export const getDemoWorkspace = () => api.get('/demo/workspace').then(r => r.data);
export const updateDemoProgress = (data) => api.patch('/demo/workspace/progress', data).then(r => r.data);
export const getDemoPreview = (perspective) => api.get(`/demo/workspace/preview/${perspective}`).then(r => r.data);
export const performDemoAction = (data) => api.post('/demo/workspace/actions', data).then(r => r.data);
export const previewDemoCleanup = () => api.post('/platform/demo-requests/cleanup-preview').then(r => r.data);
